export const API_URL = process.env.NODE_ENV === 'production' ? 'https://api.zahldo.com' : 'http://localhost:8080'

console.log('config using API_URL', API_URL)
